export default "__VITE_ASSET__BPIDK6Kh__"